import * as React from 'react';

import { ReactComponent } from '../../../../../shared/abstract/infrastructrue/ReactComponent';
import { Avatar, TAvatarProps } from './Avatar.view';

export class AvatarComponent extends ReactComponent {
  public static create({
    withLoadingStatusOptions,
    ...rest
  }: TAvatarProps): React.ReactElement<TAvatarProps> {
    return this.composeWithLoadingStatus(Avatar, {
      withLoadingStatusOptions: {
        ...withLoadingStatusOptions,
        css: {
          w: '40px',
          h: '40px',
          borderRadius: '100%',
        },
      },
    })(rest);
  }
}
